class TravelWidget extends HTMLElement {
    host = "https://widgets.theapiforge.com";
    // host = "https://local.rom-tickets.de:1324";

    async getHTML(path) {
        let request = await fetch(path);
        if (!request.ok) return;

        return await request.text();
    }

    constructor() {
        super();
        console.log("constructor");

        // this.style = new CSSStyleSheet();
        // this.style = document.createElement('link');
        // this.style.rel = 'stylesheet';
        // this.style.href = this.host + '/css/wc.css';

        this.template = document.createElement("template");
        let clone = this.template.content.cloneNode(true);

        const shadowRoot = this.attachShadow({mode: "open"});

        // const style = document.createElement('style');
        // style.textContent = `
        //     :host {
        //         --primary-color: var(--widget-primary, #007bff);
        //     }
        //     `;
        // this.shadowRoot.prepend(style);

        // const style = document.createElement('link');
        // style.rel = 'stylesheet';
        // style.href = this.host + '/css/wc.css';
        // shadowRoot.appendChild(style);

        shadowRoot.append(clone);
    }

    async connectedCallback() {
        console.log("connectedCallback");

        var url = new URL(this.host + "/v1/products");
        const params = this.dataset;
        for (let k in params) {
            url.searchParams.append(k, params[k]);
        }

        this.html = await this.getHTML(url);

        if (!this.rendered) {
            this.render();
            this.rendered = true;
        }
    }

    disconnectedCallback() {
        console.log("disconnectedCallback");
    }

    attributeChangedCallback(attrName, oldVal, newVal) {
        console.log("attributeChangedCallback");
        this.render();
    }

    render() {
        console.log("render");
        this.template.innerHTML = this.html || '';
        this.shadowRoot.innerHTML = this.html || '';

        this.twCards = this.shadowRoot.querySelectorAll(".tw-card");
        // this.twPanel = this.shadowRoot.querySelector('.tw-panel');
        // this.twPanelClose = this.twPanel.querySelectorAll('.tw-panel-close');

        // console.log("twPanelClose", this.twPanelClose);
        // this.twPanelClose.forEach((close) => {
        //   console.log("close", close);
        //   close.addEventListener('click', this._closePanel.bind(this, close));
        // });

        // this.twCards.forEach((card) => {
        //   card.addEventListener('click', this._showPanel.bind(this, card));
        // });
        this.twCards.forEach((card) => {
            // card.addEventListener("click", this._fetchDetails.bind(this, card));
        });
    }

    async _fetchDetails(card, event) {
        console.log("fetchDetails event", event);
        console.log("fetchDetails card", card);

        const uuid = card.querySelector(".uuid").innerHTML;
        console.log("uuid", uuid);

        const detailsHtml = await this.getHTML(
            this.host + "/v1/activities/" + uuid
        );
        //  console.log(detailsHtml)
        // if (this.twPanel) {
        //   this.twPanel.classList.add("hidden");
        // }
        this.shadowRoot.querySelector(".tw-details").innerHTML = detailsHtml || '';
        this.twPanel = this.shadowRoot.querySelector(".tw-panel");
        this.twPanelClose = this.shadowRoot.querySelectorAll(".tw-panel-close");
        this.twPanelClose.forEach((close) => {
            console.log("close", close);
            close.addEventListener(
                "click",
                this._closePanel.bind(this, this.twPanel)
            );
        });
        //  this.twPanel = this.html.querySelector('.tw-panel');
        this.twPanel.classList.remove("hidden");

        //  document.body.addEventListener('click', this._closePanel.bind(this, this.twPanel));
        // this.shadowRoot.getRootNode().host.addEventListener('click', this._closePanel.bind(this, this.twPanel));
        // console.log(this.shadowRoot.getRootNode().host.parentElement);
    }

    _showPanel(card, event) {
        // twPanel.classList.remove('hidden');
        console.log("showPanel event", event);
        console.log("showPanel card", card);

        const uuid = card.querySelector(".uuid").innerHTML;
        console.log("uuid", uuid);

        this.twPanel.classList.remove("hidden");
        // this.twPanel.classList.add('transform transition ease-in-out duration-500 sm:duration-700')
    }

    _closePanel(close, event) {
        console.log("closePanel event", event);
        console.log("closePanel close", close);
        this.twPanel.classList.add("hidden");
        // this.twPanel.classList.add('transform transition ease-in-out duration-500 sm:duration-700')
    }
}

if ("customElements" in window) {
    customElements.define("travel-widget", TravelWidget);
}
